<template>
    <div class="page-top fixed z-50 right-5 bottom-14 hover:opacity-70 block w-10 h-10 cursor-pointer" @click="returnTop">
        <img src="@/assets/pageTop.svg">
    </div>
</template>
<script>
export default {
    data() {
        return{
            scrollTimer:0,
            scrollY:0
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll:function() {
          if(this.scrollTimer) {
              return;
          }
          this.scrollTimer = setTimeout(() => {
              this.scrollY = window.scrollY;
              clearTimeout(this.scrollTimer);
              this.scrollTimer = 0;
          }, 100);
        },
        returnTop:function() {
            window.scrollTo({
                top:0,
                behavior: "smooth"  
            });
        },
    }
}
</script>